import React, { useContext, useEffect, useRef, useState,useCallback } from "react";
import "../../assets/css/rcTree.css";
import Tree from "rc-tree";
import { useSelector, useDispatch } from "react-redux";
import { cloneDeep, each, isArray } from "lodash";
import { treeActions } from "../../redux/slices/treeSlice";
import { MoreHoriz } from "@mui/icons-material";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import TreeLoading from "./TreeLoading";
import { eachDeep } from "deepdash-es/standalone";
import { getSelectedNodes, getStartAndEndKey } from "../RightContextMenu/ContextActions/CopyAndPaste";
import { t } from "i18next";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import {scrollToSelectedItem } from "../../utils/utilFunctions";
import { getSameLevelOrAboveLevelNode } from "./WorkflowGroupsTree";
import { FIELD_TYPE, RECORD_TYPE } from "../../constants/datatypes";
import { addNodesAndUpdateTransData, nodesValidation, removeNodesAndUpdateTransData } from "../../utils/nodesValidation";
import { getUpdatedData } from "../RightContextMenu/ContextActions/NewRecord";
import ErrorModal from "../ItemProperties/Forms/FieldDataValidation/ErrorModal";

const recordTypes = ['RECORD', 'ELEMENT', 'REPEATING_ELEMENT', 'RECORD_TOP', 'QUERY', 'CONDITION_ELSE', 'FIELD_GROUP', 'REPEATING_FIELD_GROUP', 'OBJECT'];
const floatRecords = ['ELEMENT', 'REPEATING_ELEMENT', 'CONDITION_ELSE', 'FIELD_GROUP', 'REPEATING_FIELD_GROUP', 'OBJECT'];
const heavyRecords = ['RECORD', 'QUERY'];
const fieldTypes = ['FIELD', 'DATABASE_FIELD', 'FIELD_LOOP', 'ATTRIBUTE', 'COMMENT'];

export default function InboundTemplateTree(props) {
  const parentScreen = useContext(ParentScreenCtx);
  const dispatch = useDispatch();
  const treeRef = React.createRef();
  const treeParentRef = React.createRef();

  //redux treeData references
  const { account } = useSelector((state) => state.queryParams);
  const { leftTree, rightTree, recentlyVisitedTemplates } = useSelector((state) => state.treeData[parentScreen]);
  const { workflowGroup, title } = leftTree.tree.body.selectedNode
  const templateHeader = rightTree.tree.templateHeader;
  const translatedData = rightTree.tree[props.tab].translatedData;
  const currentTab = props.tab;
  const expandActions = props.expandActions;
  const rightSelectedNode = rightTree.tree[currentTab].selectedNode;
  const activeTab = rightTree.currentTab;
  //state declarations
  const [draggedNodes, setDraggedNodes] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [dropInfo, setDropInfo] = useState(null);
  const [selectedNodes, setSelectedNodes] = useState({});
  const [expandedNodes, setExpandedNodes] = useState({});
  const [modalContent, setModalContent] = useState("");
  const [postDropSelectNodes, setPostDropSelectNodes] = useState([]);
  const [newTData, setNewTData] = useState(false);
  // const [treeDisabled, setTreeDisabled] = useState(false);
  const [isCopied, setIsCopied] = useState({ copy: false, paste: false });
  const [draggedNodesPending, setDraggedNodesPending] = useState() // This state will be used for storing nodes until user select any option in modal;
  const [errorModal, setErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const manualClick = useRef(false);

  // const handleErrorModal = () => {
  //   setErrorModal(false);
  // };
  const templatePath = `${account}/${workflowGroup}/${title}.json`;

  const modifyRecentVisitedTemplates = (node, tab) => {
    if (node) {
      const { key } = node;
      let isModified = false;
      let templates = [];
  
      templates = recentlyVisitedTemplates.map(o => {
        if (o.path === templatePath) {
          if (o.key !== key && o.tab === tab) {
            isModified = true;
            return { path: templatePath, key: key, tab: tab };
          }
          return o;
        }
        return o;
      });
  
      // Add new entry if the node with the same path and tab does not exist
      if (!recentlyVisitedTemplates.some(o => o.path === templatePath && o.tab === tab) && (key) && (key !== translatedData[0].key)) {
        templates.push({ path: templatePath, key: key, tab: tab });
        isModified = true;
      }
  
      // Dispatch the action only if the array has been modified
      if (isModified) {
        dispatch(treeActions.setRecentlyVisitedTemplates({
          screen: parentScreen,
          value: templates
        }));
      }
    }
  };
  
  
  
  // updates selectedNode obj with given node
  const dispatchSelectedNode = (node) => {
    if (node) {
      dispatch(treeActions.setRightTreeSelectedNode({
        screen: parentScreen,
        type: currentTab,
        data: {},
      }));
      setTimeout(() => {
        dispatch(
          treeActions.setRightTreeSelectedNode({
            screen: parentScreen,
            type: currentTab,
            data: node,
          })
        );
      });
    }
  }

  //updates provided state with proper map, using an array of ids
  const updateNodesByIds = (ids, setState) => {
    let nodes = {};
    each(ids, (id) => {
      getNodeById(translatedData, id, (item) => {
        nodes[id] = item.key;
      });
    })
    setState(nodes);
  }

  //updates provided state with proper map, using an array of keys
  const updateNodesByKeys = (keys, setState) => {
    let nodes = {}
    each(keys, (key) => {
      getNodeByKey(translatedData, key, (item) => {
        nodes[item.nodeId] = key;
      });
    })
    setState(nodes);
  }

  //remove old nodes after drop, push them to provided newArr
  const removeDraggedNodes = (newData, newArr) => {
    Object.keys(selectedNodes).forEach((id) => {
      if (recordTypes.includes(dropInfo.node.type)) {
        //if target node is a record type
        if (dropInfo.node.nodeId !== id) {
          //if target node id !== current selnode id
          getNodeById(newData, id, (item, index, arr) => {
            if (item.ICON_DISPLAY !== "TEMPLATE_BODY_DOTS") {
              arr.splice(index, 1);
              newArr.push(item);
            }
          });
        }
      } else {
        //target node is not record type
        getNodeById(newData, id, (item, index, arr) => {
          if (item.ICON_DISPLAY !== "TEMPLATE_BODY_DOTS") {
            arr.splice(index, 1);
            newArr.push(item);
          }
        });
      }
    });
  }

  //handle expand event for parent nodes, grouped by function for readability.
  const onExpand = (keys, detail) => {
    manualClick.current = true;
    updateNodesByKeys(keys, setExpandedNodes);

    //if selected nodes are inside a collapsing node, deselect them.
    const deselectCollapsedChildren = () => {
      if (!detail.expanded && detail.node.children) {
        let nodeChildren = detail.node.children;
        let selectedChildrenIds = [];
  
        //loop collapsed node's children, check if any are selected, push to an arr.
        each(nodeChildren, (item) => {
          if (Object.keys(selectedNodes).includes((item.nodeId))) {
            selectedChildrenIds.push(item.nodeId);
            dispatchSelectedNode({});
          }
        });
        updateNodesByIds([...Object.keys(selectedNodes).filter(id => !selectedChildrenIds.includes(id))], setSelectedNodes)

        // Deselecting Node in redux After parent node collapse.
        // if(rightSelectedNode?.key?.includes(detail?.node?.key)){
          // dispatchSelectedNode({});
          // Deseleting Node from state if it is Nested after collapse.
          // if(Object.values(selectedNodes).includes(rightSelectedNode?.key)){
          //   updateNodesByKeys([...Object.values(selectedNodes).filter(ele => ele !== rightSelectedNode?.key)], setSelectedNodes);
          // }
        // }
      }
    }
    deselectCollapsedChildren();
  };

  //handle select event for tree nodes, grouped by function for readability.
  const onSelect = (keys, data, dragSelect) => {
    manualClick.current = true;
    // TODO: find correct way to focus the tree when user clicks on it. (for using arrow keys and enter button, etc.)
    //treeRef.current.focus();

    if (dragSelect) {
      if (data) {
        let ids = Object.keys(selectedNodes).includes(data.nodeId) ? Object.keys(selectedNodes) : [data.nodeId, ...Object.keys(selectedNodes)];
        updateNodesByIds(ids, setSelectedNodes);
        dispatchSelectedNode(data);
      }
    } else {
      //set selected keys based on which keys are held during selection
      const handleMultipleSelectOptions = () => {
        // modifier keys, including MacOS metakey.
        let kb = {
          shift: data.nativeEvent ? data.nativeEvent.shiftKey : false,
          ctrl: data.nativeEvent ? data.nativeEvent.ctrlKey : false,
          metaKey: data.nativeEvent ? data.nativeEvent.metaKey : false,
        };

        if (!kb.ctrl && !kb.shift && !kb.metaKey) {
          // if none: select single node normally.
          updateNodesByKeys([data.node.key], setSelectedNodes);
        }
        else if ((kb.ctrl || kb.metaKey) && !kb.shift) {
          // if ctrl or meta, and not shift: 
          updateNodesByKeys(keys.length !== 0 ? keys : [data.node.key], setSelectedNodes)
        }
        if (kb.shift) {
          // write a function that selects all nodes by key from LAST selected node to
          // CURRENT selected node in a linear way. Selecting cross-depth will need to be handled.
          if (keys.length > 1) {
            updateNodesByKeys(
              getShiftSelectedKeys(keys, translatedData),
              setSelectedNodes
            );
          }
        }
      }
      handleMultipleSelectOptions();
      modifyRecentVisitedTemplates(data.node, activeTab)
      dispatchSelectedNode(data.node);
    }
  };

  //handle drag start event 
  const onDragStart = (info) => {
    info.event.dataTransfer.effectAllowed = "move"
    const currentSelectedNodes = Object.values(selectedNodes);
    const draggedNodes = currentSelectedNodes?.includes(info.node.key) ? currentSelectedNodes : [info.node.key];
    setDraggedNodes(draggedNodes);
  };

  //handle position of dragNode(record,field) if dropped on record
  const handleItemDrop = (isInside) => {
    const {updatedData, removedNodes, node} = draggedNodesPending;
    
    // Use the node directly (inbound templates don't have IF/ELSE pairs like workflow templates)
    const destinationNode = node;
    
    const {translatedData, selectedNode, newSelectedKeys} = addNodesAndUpdateTransData(updatedData, removedNodes, destinationNode, isInside, templateHeader.FILETYPE, currentTab, parentScreen);
    updateNewData(translatedData, selectedNode, newSelectedKeys);
    setShowModal(false);
  };

  const handleDialogShow = (modalText) => {
    setModalContent( formatModalContent(modalText) );
    setShowModal(true);
  }

  //handle drop event
  const onDrop = (info) => {
    // Store original target position before removal for proper insertion calculation
    const originalTargetKey = info.node.key;
    const originalTargetNodeId = info.node.nodeId;
    
    const {updatedData, removedNodes} = removeNodesAndUpdateTransData(translatedData, draggedNodes, parentScreen, templateHeader?.FILETYPE, false, currentTab);
    
    // Find the target node in the updated data (after removal/reindexing)
    let updatedTargetNode = null;
    const findUpdatedTarget = (data) => {
      data.forEach(node => {
        if (node.nodeId === originalTargetNodeId && node.ICON_DISPLAY === info.node.ICON_DISPLAY) {
          updatedTargetNode = node;
          return;
        }
        if (node.children) findUpdatedTarget(node.children);
      });
    };
    findUpdatedTarget(updatedData);
    
    const targetNode = updatedTargetNode || info.node;
    
    const {errorMessage, modalMessage, isInside} = nodesValidation(targetNode, removedNodes, currentTab, true, templateHeader?.FILETYPE, updatedData, parentScreen);
    
    if (modalMessage){
      handleDialogShow(t(modalMessage));
      setDraggedNodesPending({ updatedData, removedNodes, node: targetNode, originalTargetKey})
    }
    else if (errorMessage){
      setErrorMessage(t(errorMessage));
      setErrorModal(true);
    }
    else if(!showModal && !errorMessage) {
      const {translatedData, selectedNode: finalNode, newSelectedKeys} = addNodesAndUpdateTransData(updatedData, removedNodes, targetNode, isInside, templateHeader.FILETYPE, currentTab, parentScreen);
      updateNewData(translatedData, finalNode, newSelectedKeys);
    }
  }

  const updateNewData = (finalData, finalNode, newSelectedKeys) => {
    
    const newUpdatedData = getUpdatedData(finalData, templateHeader?.FILETYPE);
    // Dispatching Empty Node first will clear all states in Middle Panel and then dispatching original node
		dispatch(
			treeActions.setRightTreeSelectedNode({
				screen: parentScreen,
				type: currentTab,
				data: {},
			})
		);
		setTimeout(() => {
			dispatch(
				treeActions.setRightTreeSelectedNode({
					screen: parentScreen,
					type: currentTab,
					data: {...finalNode},
				})
			);
		})
    setSelectedNodes({[finalNode.nodeId]: finalNode?.key});
    dispatch(treeActions.setRightTreeTransData({
      screen: parentScreen,
      type: currentTab,
      data: newUpdatedData
    }))
  }



  //handle tree node right click
  const onRightClick = (info) => { 
    //if rightclicked node is not already in selectedNodes, set this node as single selected.
    if (!Object.keys(selectedNodes).includes(info.node.nodeId)) { 
      dispatchSelectedNode(info.node);
      updateNodesByIds([info.node.nodeId], setSelectedNodes);
    }
  };

  // After translatedData change, update selected nodes and expanded nodes.
  // Logic is separated by function for readablility.
  useEffect(() => {
    //on tData change, update selected nodes array.
    const updateSelNodes = () => {
      if (postDropSelectNodes.length) {
        //if from DnD - set selectedNodes to match postDropSelectNodes.
        let postDropNodeIds = [];
        postDropSelectNodes.forEach(o => postDropNodeIds.push(o.nodeId));
        updateNodesByIds(postDropNodeIds, setSelectedNodes);
        dispatchSelectedNode(postDropSelectNodes[postDropSelectNodes.length - 1]);
        setPostDropSelectNodes([]);
      } else {
        //else - set selectedNodes to match curr selnode.
        if (
          !Object.keys(selectedNodes).includes(rightSelectedNode.nodeId) &&
          Object.keys(rightSelectedNode).length > 0
        ) {
          updateNodesByIds([rightSelectedNode.nodeId], setSelectedNodes)
        }
        
        if (
          !Object.values(selectedNodes).includes(rightSelectedNode.key) &&
          Object.keys(rightSelectedNode).length > 0
          ) {
          updateNodesByKeys([rightSelectedNode.key], setSelectedNodes)
          modifyRecentVisitedTemplates(rightSelectedNode, activeTab)

        }
      }
    }

    //on tData change, update expanded nodes array
    const updateExpNodes = () => {
      //filter duplicate expand ids caused by reindexing
      let filteredENI = [...new Set(Object.keys(expandedNodes))];
      if (rightSelectedNode?.nodeId) {
        if (filteredENI.length === 0 && rightSelectedNode.nodeId === translatedData[0]?.nodeId) {
          // If the selected node is the first node, expand the first node
          filteredENI.push(rightSelectedNode.nodeId);
        }
        //if current selected node is inside a non-expanded parent, expand the parent to show the node.
        getNodeParentsById(translatedData, rightSelectedNode.nodeId, (parentIdsArray = []) => {
          updateNodesByIds([...new Set([...filteredENI,...parentIdsArray])],setExpandedNodes)
        });
      }else {
        //else update expanded nodes with filtered arr
        updateNodesByIds(filteredENI, setExpandedNodes);
      }


    }

    updateSelNodes();
    updateExpNodes();
  }, [translatedData,rightSelectedNode]);

  //trigger new tdata dispatch inside useEffect to queue it after other state changes.
  useEffect(() => {
    if (newTData) {
      dispatch(
        treeActions.setNewRightTreeTranslatedData({
          screen: parentScreen,
          type: rightTree.currentTab,
          data: newTData,
        })
      );
    }
  }, [newTData])

  // Upon fetching template, select first node in Redux store, or nothing at all
  useEffect(() => {
      
    const updateSelectedNodeInRightTree = (visitedTemplates, templatePath, tab) => {
      // Find the node in recentlyVisitedTemplates that matches the templatePath
      const matchedTemplate = visitedTemplates.find(template => (template.path === templatePath) && (template.tab === tab));
    
      if (!matchedTemplate) {
        return translatedData[0]; // Return first node if no matching template is found in list of recently visited templates
      }
    
      let matchingNode = null;
      // Traverse translatedData to find the matching node by key
      eachDeep(cloneDeep(translatedData), (obj) => {
        if ((obj?.key === matchedTemplate.key)) {
          matchingNode = obj; 
          return false; 
        }
        if (Array.isArray(obj?.children)) {
          return obj.children; 
        }
      });
    
      return matchingNode; // Return the matching node
    };
    
    if (leftTree.tree.body.selectedNode?.type === "inboundTemplate") {
      if (currentTab === "body" || translatedData.length) {
        const matchingNode = updateSelectedNodeInRightTree(recentlyVisitedTemplates,templatePath, activeTab);
        updateNodesByKeys([matchingNode?.key], setSelectedNodes);
        if(currentTab === "body") updateNodesByKeys([matchingNode?.key], setExpandedNodes);

        dispatchSelectedNode(matchingNode);
        dispatch(treeActions.setSelectedKeysArray({
          screen:parentScreen,
          type: currentTab,
          data: [matchingNode?.key]
        }))
      } else {
        setSelectedNodes([]);
        setExpandedNodes([]);
        dispatchSelectedNode({});
      }
    }
  }, [leftTree.tree.body.selectedNode?.key, templateHeader?.FILETYPE, templateHeader?.FILETYPE_VERSION, activeTab]);

  //on selectedNodes change, dispatch new key arr to selectedKeysArray.
  useEffect(() => {
    dispatch(
      treeActions.setSelectedKeysArray({
        screen: parentScreen,
        type: rightTree.currentTab,
        data: Object.values(selectedNodes),
      })
    );

    if (!manualClick.current)scrollToSelectedItem(Object.values(selectedNodes),treeParentRef);
    manualClick.current = false;
  }, [selectedNodes]);

  useEffect(()=>{
    if(expandActions?.tab === props.tab) setExpandedNodes(expandActions?.keys);
  },[expandActions])

  //define tree node icon display
  const Icon = (node) => {
    if (node.ICON_DISPLAY === "TEMPLATE_BODY_DOTS")
      return (
        <span className="tree-icon " id={node.data.key}>
          <MoreHoriz />
        </span>
      );
    else {
      return (
        <span
          className={"tree-icon " + node.ICON_DISPLAY}
          id={node.data.key}
          title={
            node?.ICON_DISPLAY === "COMMENT" ? node?.DESCRIPTION : node?.title
          }
        ></span>
      );
    }
  };

  //define tree node text display
  const titleRenderHandler = (node) => {
    return (
      <span data-key={`${node.key}`} title={node.ICON_DISPLAY === "COMMENT" ? node.DESCRIPTION : node.title}>
        {node.title}
      </span>
    );
  };

  //define tree node expand arrow icon state
  const switcherIcon = (obj) => {
    if (obj.isLeaf) return;
    if (obj.expanded) return <ArrowDropDownIcon />;
    else return <ArrowRightIcon sx={{ color: "#666666" }} />;
  };

  

  const translatedDataKeys = getKeys(translatedData);
  const collectedNodes = collectNodes(translatedData);

  const handleKeyDown = (event) => {
    event.preventDefault();
    const expandAndCollapseNode = (isExpand) =>{
      if(rightSelectedNode?.children?.length && isExpand && !Object.values(expandedNodes)?.filter(e => e === rightSelectedNode.key)?.length){
        updateNodesByKeys([...Object.values(expandedNodes), rightSelectedNode.key],setExpandedNodes);
      }else if (rightSelectedNode?.children?.length && !isExpand && Object.values(expandedNodes)?.filter(e => e === rightSelectedNode.key)?.length){
        updateNodesByKeys(Object.values(expandedNodes).filter(e => e !== rightSelectedNode.key),setExpandedNodes);
      }
    }

    const navigate = (offset) => {
      if (Object.values(selectedNodes).length === 0)  return;
      const currentIndex = translatedDataKeys.reduce((acc, ele, index) => ele?.key === Object.values(selectedNodes)[0] ? index : acc ,0);
      let newIndex = currentIndex + offset;
      let nextNodeKey = translatedDataKeys[newIndex]?.key;
      let nextNode = collectedNodes[nextNodeKey];
      const sameLevelOrAboveLevelNodeIndex = getSameLevelOrAboveLevelNode(translatedDataKeys, rightSelectedNode?.key, currentIndex,offset);

      if ((!Object.values(expandedNodes)?.filter(e => e === rightSelectedNode.key)?.length && nextNodeKey.indexOf(rightSelectedNode?.key) !== -1)
      || (!Object.values(expandedNodes)?.filter(e => e === translatedDataKeys[sameLevelOrAboveLevelNodeIndex]?.key)?.length && nextNodeKey.indexOf(translatedDataKeys[sameLevelOrAboveLevelNodeIndex]?.key) !== -1 && offset === -1)
      ){ 
        nextNodeKey = translatedDataKeys[isNaN(sameLevelOrAboveLevelNodeIndex) ? currentIndex : sameLevelOrAboveLevelNodeIndex]?.key ;
        nextNode = collectedNodes[nextNodeKey];
      }

      if (newIndex < 0 || newIndex >= translatedDataKeys.length || !nextNodeKey ){
        return;
      }
      
      updateNodesByKeys([nextNodeKey],setSelectedNodes);
      dispatch(
        treeActions.setRightTreeSelectedNode({
          screen: parentScreen,
          type: currentTab,
          data: nextNode,
        })
      );
    };
    if (event.key === "ArrowUp") {
      navigate(-1);
    } else if (event.key === "ArrowDown") {
      navigate(1);
    }else if (event.key === "ArrowRight") {
      expandAndCollapseNode(true);
    } else if (event.key === "ArrowLeft") {
      expandAndCollapseNode(false);
    }
  };
  
  useEffect(()=>{
    if (rightTree.loading) {
      setSelectedNodes({});
      setExpandedNodes({});
    }else {
      if(currentTab === "body"){
        updateNodesByKeys(["ib-0"], setExpandedNodes);
      }
      updateNodesByKeys(['ib-0'], setSelectedNodes);
    }
  },[rightTree.loading])


  useEffect( () => {
    if(rightTree?.treeActions?.expandKeys?.length && rightTree?.treeActions?.treeType === currentTab) {
      const values = Object.values(expandedNodes || {});
      const filteredKeys = rightTree?.treeActions?.expandKeys?.filter( e => !values.includes(e));
      const newExpandedKeys = [...values, ...filteredKeys];
      updateNodesByKeys(newExpandedKeys, setExpandedNodes);
      dispatch(treeActions.setTreeActions({data:{}})); // Clearing TreeActions after executing actions;
    }
  },[rightTree?.treeActions])


 return (
    <>
      <div 
       ref={treeParentRef}
       className="overflow-auto height-100 ib-tree"
       onKeyDown={handleKeyDown}
       tabIndex={0}
       // id is required in inboundTemplatePanel paste conditions
       style={{userSelect: "none", height: '100%' }} id="ib-tree"> 
        {translatedData.length && !rightTree.loading ? (
          <Tree
            focusable={true}
            disabled={false} // this can be bound to a state if we need to disable tree.
            ref={treeRef}
            className="myCls"
            showLine
            autoFocus
            treeData={translatedData}
            // onActiveChange={(key) => console.log("Active :", key)}
            onDragStart={onDragStart}
            onDrop={onDrop}
            onExpand={onExpand}
            onRightClick={onRightClick}
            onSelect={onSelect}
            draggable={true}
            icon={Icon}
            selectedKeys={Object.values(selectedNodes)}
            expandedKeys={Object.values(expandedNodes)}
            multiple
            showIcon
            switcherIcon={switcherIcon}
            selectable={true}
            titleRender={titleRenderHandler}
          ></Tree>
        ) : (
          <TreeLoading />
        )}
      </div>
      <Dialog open={showModal}>
        <DialogTitle className="dialog-header title">
          <div className="title">{t("BOX_CONFIRM")}</div>
        </DialogTitle>
        <DialogContent className="dialog-content" dividers>
          <div className="alignToHeader">{modalContent}</div>
        </DialogContent>
        <DialogActions>
          <Button
            size='small'
            variant="outlined"
            color="primary"
            onClick={() => handleItemDrop(true)}
          >
            {t("BTN_YES")}
          </Button>
          <Button
            size='small'
            variant="outlined"
            color="primary"
            onClick={() => handleItemDrop(false)}
          >
            {t("BTN_NO")}
          </Button>
          <Button
            size='small'
            variant="outlined"
            color="primary"
            onClick={() => {
              // toggle(null);
              setShowModal(false);
            }}
          >
            {t("BTN_CANCEL")}
          </Button>
        </DialogActions>
      </Dialog>
      <ErrorModal errorModal={errorModal} errorMessage={errorMessage} handleErrorModal={setErrorModal} />
    </>
  );
}

const formatModalContent = (string) => {
  let splitText = string.split(`\\n`);

  return (
    <>
      {splitText[0]}
      <br/><br/>
      {splitText[2]} 
      <br/>
      {splitText[3]} <br/>
    </>
  )
};

// Function to Get Shift Selection Keys;
export const getShiftSelectedKeys = (keys, data) => {
  // const firstKey = [0];  //prev.
  // const firstKey = keys[keys.length - 2]; //prev.

  // Setting "firstKey" to [0] completely breaks Shift clicking... 
  // changing this to "keys[0]" to use first key as anchor point.
  const firstKey = keys[0];
  const secondKey = keys[keys.length - 1];
  const { startKey, endKey } = getStartAndEndKey(firstKey, secondKey);
  const selKeys = [];
  eachDeep(data, (obj) => {
    const key = obj?.key;
    if (key && checkValidKey(key, startKey, endKey)) {
      selKeys.push(key);
    }
  });
  return selKeys;

  function checkValidKey(key, startKey, endKey) {
    if (key === startKey || key === endKey) {
      return true;
    }

    const keyArray = key.split("-").splice(1);
    const startKeyArray = startKey.split("-").splice(1);
    const endKeyArray = endKey.split("-").splice(1);
    const keySize = keyArray.length;
    const startKeySize = startKeyArray.length;
    const endKeySize = endKeyArray.length;

    if (keySize < startKeySize) {
      // When Current Key is Smaller than Start Key Size and End Key Size
      if (keySize < endKeySize) {
        let isKeyValid1 = true;
        let isKeyValid2 = true;

        for (let i = 0; i < keySize; i++) {
          const num1 = Number(keyArray[i]);
          const num2 = Number(startKeyArray[i]);
          if (num1 < num2) {
            isKeyValid1 = false;
            break;
          }
          if (num1 > num2) {
            isKeyValid1 = true;
            break;
          }
        }
        if (startKey.includes(key)) isKeyValid1 = false;

        for (let i = 0; i < keySize; i++) {
          const num1 = Number(keyArray[i]);
          const num2 = Number(endKeyArray[i]);
          if (num1 > num2) {
            isKeyValid2 = false;
            break;
          }
          if (num1 < num2) {
            isKeyValid2 = true;
            break;
          }
        }
        if (key.includes(endKey)) isKeyValid2 = false;

        return isKeyValid1 && isKeyValid2;

        // When Current Key is Smaller than Start Key Size and greater than End Key Size
      } else if (keySize > endKeySize) {
        let isKeyValid1 = false;
        let isKeyValid2 = false;

        for (let i = 0; i < keySize; i++) {
          const num1 = Number(keyArray[i]);
          const num2 = Number(startKeyArray[i]);
          if (num1 < num2) {
            isKeyValid1 = false;
            break;
          }
          if (num1 > num2) {
            isKeyValid1 = true;
            break;
          }
        }
        if (startKey.includes(key)) isKeyValid1 = false;

        for (let i = 0; i < endKeySize; i++) {
          const num1 = Number(keyArray[i]);
          const num2 = Number(endKeyArray[i]);
          if (num1 < num2) {
            isKeyValid2 = true;
            break;
          }
          if (num1 > num2) {
            isKeyValid2 = false;
            break;
          }
        }
        if (endKey.includes(key)) isKeyValid2 = true;

        return isKeyValid1 && isKeyValid2;

        // When Current Key is Smaller than Start Key Size and equal End Key Size
      } else if (keySize === endKeySize) {
        let isKeyValid1 = true;
        let isKeyValid2 = false;
        for (let i = 0; i < keySize; i++) {
          const num1 = Number(keyArray[i]);
          const num2 = Number(startKeyArray[i]);
          if (num1 < num2) {
            isKeyValid1 = false;
            break;
          }
          if (num1 > num2) {
            isKeyValid1 = true;
            break;
          }
        }
        if (startKey.includes(key)) isKeyValid1 = false;

        for (let i = 0; i < endKeySize; i++) {
          const num1 = Number(keyArray[i]);
          const num2 = Number(endKeyArray[i]);
          if (num1 > num2) {
            isKeyValid2 = false;
            break;
          }
          if (num1 < num2) {
            isKeyValid2 = true;
            break;
          }
        }
        return isKeyValid1 && isKeyValid2;
      }
    } else if (keySize > startKeySize) {
      // When Current Key is greater than Start Key Size and smaller than End Key Size
      if (keySize < endKeySize) {
        let isKeyValid1 = true;
        let isKeyValid2 = false;

        for (let i = 0; i < startKeySize; i++) {
          const num1 = Number(keyArray[i]);
          const num2 = Number(startKeyArray[i]);
          if (num1 < num2) {
            isKeyValid1 = false;
            break;
          }
          if (num1 > num2) {
            isKeyValid1 = true;
            break;
          }
        }
        if (startKey.includes(key)) isKeyValid1 = true;

        for (let i = 0; i < keySize; i++) {
          const num1 = Number(keyArray[i]);
          const num2 = Number(endKeyArray[i]);
          if (num1 < num2) {
            isKeyValid2 = true;
            break;
          }
          if (num1 > num2) {
            isKeyValid2 = false;
            break;
          }
        }
        if (endKey.includes(key)) isKeyValid2 = true;

        return isKeyValid1 && isKeyValid2;

        // When Current Key is greater than Start Key Size and End Key Size
      } else if (keySize > endKeySize) {
        let isKeyValid1 = true;
        let isKeyValid2 = false;

        for (let i = 0; i < keySize; i++) {
          const num1 = Number(keyArray[i]);
          const num2 = Number(startKeyArray[i]);
          if (num1 < num2) {
            isKeyValid1 = false;
            break;
          }
          if (num1 > num2) {
            isKeyValid1 = true;
            break;
          }
        }
        if (startKey.includes(key)) isKeyValid1 = true;

        for (let i = 0; i < endKeySize; i++) {
          const num1 = Number(keyArray[i]);
          const num2 = Number(endKeyArray[i]);
          if (num1 < num2) {
            isKeyValid2 = true;
            break;
          }
          if (num1 > num2) {
            isKeyValid2 = false;
            break;
          }
        }
        if (endKey.includes(key) && endKeySize > keySize) isKeyValid2 = false;

        return isKeyValid1 && isKeyValid2;

        // When Current Key is greater than Start Key Size and equal to End Key Size
      } else if (keySize === endKeySize) {
        let isKeyValid1 = true;
        let isKeyValid2 = false;

        for (let i = 0; i < keySize; i++) {
          const num1 = Number(keyArray[i]);
          const num2 = Number(startKeyArray[i]);
          if (num1 < num2) {
            isKeyValid1 = false;
            break;
          }
          if (num1 > num2) {
            isKeyValid1 = true;
            break;
          }
        }
        if (startKey.includes(key)) isKeyValid1 = true;

        for (let i = 0; i < endKeySize; i++) {
          const num1 = Number(keyArray[i]);
          const num2 = Number(endKeyArray[i]);
          if (num1 < num2) {
            isKeyValid2 = true;
            break;
          }
          if (num1 > num2) {
            isKeyValid2 = false;
            break;
          }
        }
        if (endKey.includes(key) && endKeySize > keySize) isKeyValid2 = false;

        return isKeyValid1 && isKeyValid2;
      }
    } else {
      // When Current Key is equal to Start Key Size and smaller than End Key Size

      if (keySize < endKeySize) {
        let isKeyValid1 = true;
        let isKeyValid2 = true;

        for (let i = 0; i < startKeySize; i++) {
          const num1 = Number(keyArray[i]);
          const num2 = Number(startKeyArray[i]);
          if (num1 < num2) {
            isKeyValid1 = false;
            break;
          }
          if (num1 > num2) {
            isKeyValid1 = true;
            break;
          }
        }

        for (let i = 0; i < keySize; i++) {
          const num1 = Number(keyArray[i]);
          const num2 = Number(endKeyArray[i]);
          if (num1 > num2) {
            isKeyValid2 = false;
            break;
          }
          if (num1 < num2) {
            isKeyValid2 = true;
            break;
          }
        }
        if (endKeyArray.includes(key)) isKeyValid2 = true;

        return isKeyValid1 && isKeyValid2;

        // When Current Key is equal to Start Key Size and greater than End Key Size
      } else if (keySize > endKeySize) {
        let isKeyValid1 = false;
        let isKeyValid2 = false;

        for (let i = 0; i < startKeySize; i++) {
          const num1 = Number(keyArray[i]);
          const num2 = Number(startKeyArray[i]);
          if (num1 < num2) {
            isKeyValid1 = false;
            break;
          }
          if (num1 > num2) {
            isKeyValid1 = true;
            break;
          }
        }

        for (let i = 0; i < keySize; i++) {
          const num1 = Number(keyArray[i]);
          const num2 = Number(endKeyArray[i]);
          if (num1 > num2) {
            isKeyValid2 = false;
            break;
          }
          if (num1 < num2) {
            isKeyValid2 = true;
            break;
          }
        }

        return isKeyValid1 && isKeyValid2;

        // When Current Key is equal to Start Key Size and End Key Size
      } else if (keySize === endKeySize) {
        let isKeyValid1 = false;
        let isKeyValid2 = false;

        for (let i = 0; i < startKeySize; i++) {
          const num1 = Number(keyArray[i]);
          const num2 = Number(startKeyArray[i]);
          if (num1 < num2) {
            isKeyValid1 = false;
            break;
          }
          if (num1 > num2) {
            isKeyValid1 = true;
            break;
          }
        }

        for (let i = 0; i < keySize; i++) {
          const num1 = Number(keyArray[i]);
          const num2 = Number(endKeyArray[i]);
          if (num1 > num2) {
            isKeyValid2 = false;
            break;
          }
          if (num1 < num2) {
            isKeyValid2 = true;
            break;
          }
        }

        return isKeyValid1 && isKeyValid2;
      }
    }
  }
};

// loop through tree data, return callback with node info if key is found, and exit loop.
const getNodeByKey = (_data, key, callback) => {
  let exitLoop = false;
  const loopNode = (data) => {
    each(data, (item, index, arr) => {
      if (exitLoop) return false;
      if (item.key === key) {
        exitLoop = true;
        return callback(item, index, arr);
      }
      if (item.children) loopNode(item.children);
    })
  }
  return loopNode(_data);
};

// loop through tree data, return callback with node info if id is found, and exit loop.
const getNodeById = (_data, id, _callback) => {
  let exitLoop = false;
  const loopNode = (data) => {
    each(data, (item, index, arr) => {
      if (exitLoop) return false;
      if (!item) return;
      if (item.nodeId === id) {
        exitLoop = true;
        return _callback(item, index, arr);
      }
      if (item.children) loopNode(item.children);
    })
  }
  return loopNode(_data);
};

// loop through tree data, return callback with parent info if id is found, and exit loop.
const getNodeParentById = (_data, id, callback) => {
  let exitLoop = false;
  const loopNode = (data, parent) => {
    each(data, (item) => {
      if (exitLoop) return false;
      if (item.nodeId === id) {
        exitLoop = true;
        return callback(parent || false);
      }
      if (item.children) loopNode(item.children, item);
    })
  }
  return loopNode(_data, false);
};

export const getNodeParentsById = (_data, id, callback) => {
  let exitLoop = false;
  const loopNode = (data, parentIdsArray) => {
    each(data, (item) => {
      if (exitLoop) return ;
      if (item.nodeId === id) {
        exitLoop = true;
        callback(parentIdsArray)
        return;
      }
      
      if (item.children) loopNode(item.children, [...parentIdsArray,item?.nodeId]);
    })
  }
  loopNode(_data, []);
};

export const getNodeParentsByAltId = (_data, id, callback) => {
  let exitLoop = false;
  const loopNode = (data, parentIdsArray) => {
    each(data, (item) => {
      if (exitLoop) return ;
      if (item.alternateNodeId === id) {
        exitLoop = true;
        callback(parentIdsArray)
        return;
      }
      
      if (item.children) loopNode(item.children, [...parentIdsArray,item?.key]);
    })
  }
  loopNode(_data, []);
};

export const getNodeParentsByKey = (_data, key, callback) => {
  let exitLoop = false;
  const loopNode = (data, parentKeysArray) => {
    each(data, (item) => {
      if (exitLoop) return ;
      if (item.key === key) {
        exitLoop = true;
        callback(parentKeysArray)
        return;
      }
      
      if (item.children) loopNode(item.children, [...parentKeysArray,item?.key]);
    })
  }
  loopNode(_data, []);
};


export function getKeys(translatedData) {
  const keys = [];

  function collectKeys(node,nestedLevel = 0) {
    if (node && node.key) {
      keys.push({
        key: node.key,
        isParent : node?.children?.length > 0 ? true : false,
        nestedLevel : nestedLevel + 1
      });
    }

    if (node && Array.isArray(node.children)) {
      for (const child of node.children) {
        collectKeys(child, nestedLevel + 1);
      }
    }
  }

  for (const item of translatedData) {
    collectKeys(item);
  }
  return keys;
}

export function collectNodes(treeData,collectedNodes = {}) {
  if (Array.isArray(treeData)) {
    for (const item of treeData) {
        collectedNodes[item.key] = item;
        if (item.children) {
        collectNodes(item.children,collectedNodes);
      }
    }
  }
  return collectedNodes;
}